module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_07A.ff8625e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_07A.mp3
// module id = 118
// module chunks = 0